<div class="table-container">
  <div class="table-list">
    <div class="table-header">
      <div class="d-flex flex-row align-items-center ps-4">
        <mat-icon class="scale-2">people</mat-icon>
        <h1 class="m-4 ">Pulpo Users</h1>
      </div>
    </div>

    <app-user-filter (filterEvent)="applyFilter($event)"></app-user-filter>

    <mat-divider></mat-divider>

    <table mat-table [dataSource]="dataSource" matSort (matSortChange)="sortChanged()" class="w-100">
      <ng-container matColumnDef="firstName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Prénom
        </th>
        <td mat-cell *matCellDef="let user">{{ user.firstName }}</td>
      </ng-container>
      <ng-container matColumnDef="lastName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Nom</th>
        <td mat-cell *matCellDef="let user">
          {{ user.lastName }}
        </td>
      </ng-container>
      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
        <td mat-cell *matCellDef="let user">{{ user.email }}</td>
      </ng-container>
      <ng-container matColumnDef="groups">
        <th mat-header-cell *matHeaderCellDef>Groupes et Permissions/roles</th>
        <td mat-cell *matCellDef="let user">
          <div class="groups-container">
            <ng-container *ngIf="getFormattedGroups(user.groupDescriptions).length > 0; else noGroups">
              <div *ngFor="let group of getFormattedGroups(user.groupDescriptions)" class="group-item">
                <div class="group-chip" (click)="toggleGroupExpanded(user.id, group.name)">
                  <mat-icon class="expand-icon" [class.expanded]="isGroupExpanded(user.id, group.name)">
                    chevron_right
                  </mat-icon>
                  <strong>{{ group.name }}</strong>
                  <span class="permission-count">({{ group.permissions.length }})</span>
                </div>
                <div *ngIf="isGroupExpanded(user.id, group.name)" class="permissions-list">
                  <span *ngFor="let permission of group.permissions" class="permission-badge">
                    {{ permission }}
                  </span>
                </div>
              </div>
            </ng-container>
            <ng-template #noGroups>
              <span class="no-groups">Aucun groupe</span>
            </ng-template>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="agencyName">
        <th mat-header-cell *matHeaderCellDef>Agence</th>
        <td mat-cell *matCellDef="let user">{{ getAgencyName(user.groupDescriptions) }}</td>
      </ng-container>
      <ng-container matColumnDef="createdAt">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Créé le</th>
        <td mat-cell *matCellDef="let user">
          {{ user.createdAt | date: 'dd/MM/yyyy' }}
        </td>
      </ng-container>
      <ng-container matColumnDef="options">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let user">
          <div class="row buttons-container">
            <div>
              <button mat-icon-button [matTooltip]="user.activated ? 'Désactiver' : 'Activer'"
                (click)="onActivationToggle(user)">
                <mat-icon [ngClass]="{
                    'text-success': user.activated,
                    'text-danger': !user.activated
                  }">person</mat-icon>
              </button>
            </div>
            <div *ngIf="isImpersonable(user)">
              <button mat-icon-button matTooltip="Ouvrir une session en tant que cet utilisateur"
                (click)="openImpersonationDialog(user)" data-testid="user-impersonate">
                <mat-icon [style.color]="'var(--warning, #ffb300)'">switch_account</mat-icon>
              </button>
            </div>
            <div>
              <button mat-icon-button matTooltip="Éditer l'utilisateur" (click)="openUserEditDialog(user.id)">
                <mat-icon [style.color]="'var(--primary)'">edit</mat-icon>
              </button>
            </div>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
    <mat-paginator [length]="nbUsers" (page)="changePage()" [pageSize]="itemsPerPage" showFirstLastButtons
      class="w-100 mat-paginator-sticky"></mat-paginator>
  </div>
</div>